import { strings } from "../../localization/";
import React, { useCallback, useEffect } from "react";
import { Accordeon } from "../Accordeon";
import { Box, Grid, ResponsiveLayout, Text7, useScreenSize } from "@telefonica/mistica";
import { useAnalytics } from "../../hooks/useAnalytics";
import { getFFSecondQiTechAccount } from "../../services/SystemConfiguration";

export interface IPropsFaq {
	backgroundColor?: string;
	analyticStepName: string;
}

export const FAQ: React.FC<IPropsFaq> = (props) => {
	const { commonQuestions, title } = strings.components.faq;
	const { backgroundColor, analyticStepName } = props;
	const { isDesktopOrBigger } = useScreenSize();
	const [openIndex, setOpenIndex] = React.useState<number | null>(null);
	const [secondAccountQiTech, setSecondAccountQiTech] = React.useState(false);

	const { addAnalyticEvent } = useAnalytics();

	const handleItemClick = (index: number): void => {
		setOpenIndex(index === openIndex ? null : index);
	};

	const handleAnalyticInteraction = (description: string): void => {
		addAnalyticEvent(
			{
				component: "body",
				action: "click:button",
				description,
				step: analyticStepName,
			},
			{ applySanitize: true },
		);
	};

	// Busca valor da feature flag isVisibleColdSimulationFGTS
	const fetchFeatureFlag = useCallback(async (): Promise<void> => {
		const isVisibleColdSimulationFGTS = await getFFSecondQiTechAccount();
		setSecondAccountQiTech(isVisibleColdSimulationFGTS);
	}, []);

	useEffect(() => {
		fetchFeatureFlag();
	}, []);

	const renderEntries = commonQuestions(secondAccountQiTech).map((group, index) => (
		<Accordeon
			key={index}
			title={group.question}
			text={group.answer}
			onItemClick={handleItemClick}
			index={index}
			isOpen={index === openIndex}
			itemTaggin={handleAnalyticInteraction}
		/>
	));

	return (
		<ResponsiveLayout backgroundColor={backgroundColor} className="faq-simulator-resume">
			<Grid columns={{ maxSize: 886 }} justifyContent="center">
				<Box paddingTop={isDesktopOrBigger ? 56 : 24} paddingBottom={isDesktopOrBigger ? 56 : 40}>
					<Text7>{title}</Text7>
					<Box paddingTop={32}>
						<Grid columns={{ maxSize: 808 }}>{renderEntries}</Grid>
					</Box>
				</Box>
			</Grid>
		</ResponsiveLayout>
	);
};
